import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ProfileState } from './types';
import { RootState } from '@/store/types';

export const state: ProfileState = {
    selectedProfile: null,
    activeProfileId: null,
    activeBrandId: null,
    profiles: [],
    brands: [],
    companies: [],
    profileCategories: [],
    filters: {},
};
const namespaced: boolean = true;

export const profile: Module<ProfileState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
